import { NgModule } from '@angular/core';
import { RouterModule, Routes, withEnabledBlockingInitialNavigation } from '@angular/router';
import { LayoutSessionComponent } from './shared/layouts/layout-session/layout-session.component';
import { SessionGuard } from './guards/session-auth.guard';
import { LayoutBlankComponent } from './shared/layouts/layout-blank/layout-blank.component';
import { environment } from '@env/environment';

const routes: Routes = [
	{
		path: '',
		component: LayoutSessionComponent,
		children: [
			{
				path: '',
				loadChildren: () => import('./views/public/public.module').then(m => m.PublicModule)
			}
		]
	},
	{
		path: 'painel',
		loadChildren: () => import('./views/private/private.module').then(m => m.PrivateModule),
		canLoad: [SessionGuard]
	},
	{
		path: '',
		component: LayoutBlankComponent,
		children: [
			{
				path: '',
				loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule)
			}
		]
	},
	{
		path: 'dashboard',
		loadChildren: () => import('./views/private/dashboard/dashboard.module').then(m => m.DashboardModule)
	},
	{
		path: '**',
		redirectTo: environment.home
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'enabledBlocking'
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
